import doAddToPortfolio from '@/api/doAddToPortfolio';
import useEvents from '@/hooks/useEvents';
import { useAnalytics } from '@/hooks/useAnalytics';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { PortfolioSkuPayload } from '@/types/api/api-v2';
import { CommonEnum } from '@/types/translations/CommonEnum';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRef } from 'react';
import { Id, toast } from 'react-toastify';

function useMutatePortfolio() {
  const { translate } = useTypedTranslation<CommonEnum>('common');
  const queryClient = useQueryClient();
  const toastId = useRef<Id | null>(null);
  const { getPageType } = useAnalytics();
  const { fireAddPortfolioButtonClickEvent } = useEvents('', []);

  const addBottlePortfolioMutation = useMutation({
    mutationKey: ['user/portfolio', 'bottle'],
    mutationFn: (data: PortfolioSkuPayload) => {
      fireAddPortfolioButtonClickEvent({
        page_type: getPageType(),
        slug: data.slug,
      });
      return doAddToPortfolio(data.slug, data.purchaseDate, data.quantity, data.purchasePrice);
    },
    onMutate: async () => {
      toastId.current = toast.loading(translate(CommonEnum['adding_bottle_to_portfolio']));
    },
    onError: () => {
      if (toastId.current) {
        toast.dismiss(toastId.current);
      }
      toast.error(translate(CommonEnum['error_adding_bottle']));
    },
    onSuccess: async () => {
      if (toastId.current) {
        toast.dismiss(toastId.current);
      }

      await queryClient.refetchQueries({
        queryKey: ['user/portfolio'],
      });

      toast.success(translate(CommonEnum['successful_bottle_addition']));
    },
  });

  return {
    addBottlePortfolioMutation,
  };
}

export { useMutatePortfolio };
